import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Project')
export class Project {
  @JsonProperty('code', String, false)
  public code = '';

  @JsonProperty('information', String, false)
  public information = '';

  @JsonProperty('example', String, false)
  public example = '';

  @JsonProperty('insuranceOption', String, false)
  public insuranceOption = '';

  @JsonProperty('reservedOffer', String, false)
  public reservedOffer = '';

  @JsonProperty('footNotes', [String], false)
  public footNotes: string[] = [];

  @JsonProperty('legalInformation', String, false)
  public legalInformation = '';
}

@JsonObject('CommercialOffer')
export class CommercialOffer {
  @JsonProperty('show', String, false)
  public show = 'false';

  @JsonProperty('bannerTitle', String, false)
  public bannerTitle = '';

  @JsonProperty('offerTitle', String, false)
  public offerTitle = '';

  @JsonProperty('icon', String, false)
  public icon = '';

  @JsonProperty('offerContent', String, false)
  public offerContent = '';

  @JsonProperty('legalWarning', String, false)
  public legalWarning = '';
}

@JsonObject('Disclaimer')
export class Disclaimer {
  @JsonProperty('notConnected', String, false)
  public notConnected = '';

  @JsonProperty('connected', String, false)
  public connected = '';
}

@JsonObject('PublishablesAreas')
export class PublishablesAreas {
  @JsonProperty('commercialOffer', CommercialOffer, false)
  public commercialOffer = new CommercialOffer();

  @JsonProperty('hbLegalWarning', String, false)
  public hbLegalWarning = '';

  @JsonProperty('projects', [Project], false)
  public projects: Project[] = [];

  @JsonProperty('disclaimer', Disclaimer, false)
  public disclaimer = new Disclaimer();
}
